import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeSubstanceParentCodeFields } from "../Entity/TreeNodeSubstanceParentCodeFields";
import { environment } from "../../../../../../environments/environment";


export class TreeNodeSubstanceParentCodeFieldsList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Substance Parent Code ({param})');
      this.parent = parent;
      this.labelNodeName = 'Substance Parent Code';      
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeSubstanceParentCodeFields(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override getMessage(): any {
      let internationalparentcodes: Art57Node[] = [];
      this.children?.forEach((node) => {
        let internationalcode = node as Art57Node;
        internationalparentcodes.push(internationalcode.getMessage());
      });
  
      if (internationalparentcodes.length > 0) {
        return { internationalparentcodes: { internationalcode: internationalparentcodes } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['Substance Type', 'Parent Substance'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeSubstanceParentCodeFieldsList =
        new TreeNodeSubstanceParentCodeFieldsList(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }
  }